import type { OgsmAccess } from '@/services/portal.service'

/**
 * The capability the backend's internal check mirrors: Greybull users only.
 *
 * It and `VITE_OGSM_ENABLED` only decide what the UI shows. The backend answers
 * 404 to every company role on `/companies/:id/ogsm/*`, which is what actually
 * enforces access.
 */
export const OGSM_CAPABILITY = 'company:view:all'

/** From `/auth/me` for a PortCo user with an active assignment; gates the portal OGSM tab. */
export const PORTAL_OGSM_VIEW_CAPABILITY = 'ogsm:view:own'

/** PORTCO_ADMIN, or PORTCO_STANDARD at level EDIT. */
export const PORTAL_OGSM_EDIT_CAPABILITY = 'ogsm:edit:own'

/** From `/auth/me` for a Greybull user who may edit the internal board (backend `internalCanEditOgsm`). */
export const OGSM_INTERNAL_EDIT_CAPABILITY = 'ogsm:edit:all'

export const OGSM_ACCESS_LABELS = {
  READ_ONLY: 'Read only',
  EDIT: 'Edit + Read only',
} as const satisfies Record<OgsmAccess, string>

export const OGSM_ACCESS_COPY = {
  field: 'OGSM access',
  helper:
    'Read only can view the OGSM board. Edit + Read only can also change it.',
  adminHelper: 'Admins can always edit.',
  selfHelper: "You can't change your own OGSM access. Ask another admin.",
  rowLabel: (canEdit: boolean) =>
    `OGSM: ${canEdit ? OGSM_ACCESS_LABELS.EDIT : OGSM_ACCESS_LABELS.READ_ONLY}`,
} as const
